import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 40 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ overline, title, className = "" }) => (
  <div className={className}>
    <Reveal>
      <p className="overline-label">{overline}</p>
    </Reveal>
    <Reveal delay={0.1}>
      <h2 className="font-serif-display text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-[#F4F1EA] mt-4 leading-[1.1]">
        {title}
      </h2>
    </Reveal>
  </div>
);
